export default {
    activateTitle: 'Aktiver kort',
    activateInfoBox1:
        'Kortet er bestilt, men ikke aktivert ennå. Du kan likevel aktivere det nå, sånn at du kan benytte deg av det digitale kortet.',
    activateInfoBox2:
        'Kortet er bestilt, men ikke aktivert ennå. Du kan likevel aktivere det nå, sånn at du kan benytte deg av det digitale kortet i handel på nett og/eller i apper på mobil, på TVen eller i andre digitale kanaler.',
    activateButton: 'Aktiver kortet nå',
};
